import { Chart } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import { Chart as ChartModel } from "../../../utils/models";

import withChart from "../../hoc/withChart";

ChartJS.register(...registerables);

const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom" as const,
    },
    title: {
      display: true,
      text: "",
    },
  },
  scales: {
    x: {
      display: true,
      grid: {
        drawOnChartArea: false,
      },
    },
    y: {
      display: true,
      grid: {
        drawOnChartArea: false,
      },
    },
  },
};

const Line = (props: ChartModel): JSX.Element => {
  return (
    <Chart
      ref={props.chartRef}
      type="line"
      data={props.chartData}
      options={options}
    />
  );
};

export default withChart(Line);
